import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {CertService} from "../dashboard/services/cert.service";
import {UserService} from "../dashboard/services/user.service";
import {AttendanceType} from "../dashboard/models/attendance-type";
import {JwtHelperService} from "@auth0/angular-jwt";
import {DocumentTypes} from "../../_models/document-type";
import {MatDialog} from "@angular/material/dialog";
import {AddUserCertificationModal} from "./modals/add-user-certification.modal";
import {InformationDialog} from "../../_shared/dialog/information.dialog";
import {CertificationListComponent} from "./certification-list.component";
import {UploadCeuCreditModal} from "./modals/upload-ceu-credit.modal";
import {WalletCeuListComponent} from "./wallet-ceu-list.component";
import {ProfileMessage} from "../../_services/profile.message";
import {MatTabGroup} from "@angular/material/tabs";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'my-wallet',
  templateUrl: './my-wallet.component.html',
  styleUrls: ['./my-wallet.component.scss'],
})
export class MyWalletComponent implements OnInit, AfterViewInit {
  attendanceTypes: any;
  documentTypes: DocumentTypes[];

  isLoggedIn?: boolean;
  user: any;
  certMax: any;
  currentCerts = 0;
  requestingTranscript: boolean;

  @ViewChild(CertificationListComponent) certificationList: CertificationListComponent;
  @ViewChild(WalletCeuListComponent) walletCeuList: WalletCeuListComponent;
  @ViewChild('userDtlTabGroup', { static: false }) userDtlTabGroup!: MatTabGroup;

  constructor(
    private certService: CertService,
    private userService: UserService,
    private jwtHelper: JwtHelperService,
    private dialog: MatDialog,
    private profileMsg: ProfileMessage,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
  }

  openModalAddCertification() {
    const screenWidth = window.innerWidth;
    const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
    const dialog = this.dialog.open(AddUserCertificationModal, {
      width: dialogWidth,
      maxWidth: '100%',
      data: {
        mode: 'new'
      }
    });

    dialog.componentInstance.result.subscribe(r => {
      if(r) {
        this.certificationList.query();
      }
    })
  }

  goAddCeuCredit() {
      this.router.navigate(['/my-wallet/ceu/new'], {queryParams: {mode: 'new'}}).then();
  }

  openModalAddCeuCredit() {
    const screenWidth = window.innerWidth;
    const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
    const dialog = this.dialog.open(UploadCeuCreditModal, {
      width: dialogWidth,
      maxWidth: '100%',
      data: {
        mode: 'new'
      }
    });

    dialog.componentInstance.result.subscribe(r => {
      if(r) {
        this.walletCeuList.query();
      }
    })
  }

  checkAbilityToAddMore() {
    const screenWidth = window.innerWidth;
    const dialogWidth = screenWidth < 768 ? '90vw' : '800px';

    if(this.user && this.user.accountType != 'FREE') {
      if(this.currentCerts >= this.certMax) {
        this.dialog.open(InformationDialog, {
          width: dialogWidth,
          maxWidth: '100%',
          data: {
            message: "",
            subMessage: "You've reached your subscription limit for adding certifications. Please upgrade your plan to upload more certifications. You can upgrade by clicking on the 'Upgrade Plan' menu"
          }
        });
      } else {
        this.openModalAddCertification();
      }
    }else {
      this.dialog.open(InformationDialog, {
        width: dialogWidth,
        maxWidth: '100%',
        data: {
          message: '',
          subMessage: 'Your subscription type is FREE. Please upgrade your plan to upload more certifications. You can upgrade by clicking on Upgrade Plan menu'
        }
      });
    }
  }

  setNumberCertMax($event: number) {
    this.currentCerts = $event;
  }

  async ngOnInit(): Promise<void> {
    this.isLoggedIn = !this.jwtHelper.isTokenExpired();
    if (this.isLoggedIn) {
      this.profileMsg.currentMessage.subscribe(r => {
        if(r) {
          this.user = r;
        }
      })

       this.certService.getLimit().then(product => {
         this.certMax = product.certificateLimit;
         this.attendanceTypes = Object.values(AttendanceType);
         this.documentTypes = Object.values(DocumentTypes);
       }, err => {
         if(err.error.status == 401) {
          const dialog = this.dialog.open(InformationDialog, {
            data: {
              message: 'Subscription not found',
              subMessage: 'We cannot find Stripe subscription for your account, it will redirect to subscription page after you press Ok button'
            }
          });
          dialog.componentInstance.result.subscribe(r => {
            if(r) {
              this.router.navigate(['/billing']);
            }
          })
         }
       });
    }
  }

  ngAfterViewInit() {
    const tab = this.activatedRoute.snapshot.queryParams.tab;
    if(tab) {
      switch (tab) {
        case 'scorecard': {
          this.userDtlTabGroup.selectedIndex = 2;
          break;
        }
        case 'ceus': {
          this.userDtlTabGroup.selectedIndex = 1;
          break;
        }
        default: {
          this.userDtlTabGroup.selectedIndex = 0;
          break;
        }
      }
    }
  }

  getTranscript() {

    this.requestingTranscript = true;
    this.userService.getUserTranscript().then(data => {
      const url = window.URL.createObjectURL(data);
      const a = document.createElement('a');
      a.href = url;
      a.download = `transcript.pdf`;
      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      this.requestingTranscript = false;
    });
  }

  getRefreshCeuCredit($event: any) {
    if($event == 'refresh') {
      this.walletCeuList.query();
    }

  }
}
